<!-- 实物审批退件信息 -->
<template>
	<el-dialog :visible.sync="visible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" class="role-dialog" width="70%">
		<span slot="title" class="dialog-title">
			<img src="@/assets/images/close.png" alt="" @click="visible = false" />
		</span>
		<el-form :model="dataForm" :rules="dataRule" label-position="top" ref="dataForm">
			<el-form-item label="快递单号" prop="expressNumber">
				<el-input v-model="dataForm.expressNumber" placeholder="如果没有快递单号则填无"></el-input>
			</el-form-item>
			<div class="flex">
				<div class="flex-1 mr10">
					<el-tag>寄件方</el-tag>
					<el-form-item label="" prop="sendAdvanceCode">
						<el-select
							v-model="dataForm.sendAdvanceCode"
							filterable
							remote
							placeholder="请选择"
							@change="(value) => handleSelect('0', value)"
							:remote-method="(query) => getClaimRepairAdvance('0', '', query)">
							<el-option
								v-for="item in sendOptions"
								:key="item.advanceCode"
								:label="`${item.advanceCode}/${item.companyName}/${item.address}/${item.telephone}/${item.contact}`"
								:value="item.advanceCode"></el-option>
						</el-select>
					</el-form-item>
					<div class="flex">
						<div class="flex-1 mr10">
							<el-form-item label="省" prop="sendProvince">
								<el-input v-model="dataForm.sendProvince" placeholder="请输入"></el-input>
							</el-form-item>
						</div>
						<div class="flex-1 ml10">
							<el-form-item label="市" prop="sendCity">
								<el-input v-model="dataForm.sendCity" placeholder="请输入"></el-input>
							</el-form-item>
						</div>
					</div>
					<el-form-item label="详细地址" prop="sendAddressDetail">
						<el-input v-model="dataForm.sendAddressDetail" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="sendPhone">
						<el-input v-model="dataForm.sendPhone" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="姓名" prop="sendUserName">
						<el-input v-model="dataForm.sendUserName" placeholder="请输入"></el-input>
					</el-form-item>
				</div>
				<div class="flex-1 ml10">
					<el-tag type="danger">收件方</el-tag>
					<el-form-item label="" prop="deliveryAdvanceCode">
						<el-select
							v-model="dataForm.deliveryAdvanceCode"
							filterable
							remote
							placeholder="请选择"
							@change="(value) => handleSelect('1', value)"
							:remote-method="(query) => getClaimRepairAdvance('1', '', query)">
							<el-option
								v-for="item in deliveryOptions"
								:key="item.advanceCode"
								:label="`${item.advanceCode}/${item.companyName}/${item.address}/${item.telephone}/${item.contact}`"
								:value="item.advanceCode"></el-option>
						</el-select>
					</el-form-item>
					<div class="flex">
						<div class="flex-1 mr10">
							<el-form-item label="省" prop="deliveryProvince">
								<el-input v-model="dataForm.deliveryProvince" placeholder="请输入"></el-input>
							</el-form-item>
						</div>
						<div class="flex-1 ml10">
							<el-form-item label="市" prop="deliveryCity">
								<el-input v-model="dataForm.deliveryCity" placeholder="请输入"></el-input>
							</el-form-item>
						</div>
					</div>
					<el-form-item label="详细地址" prop="deliveryAddressDetail">
						<el-input v-model="dataForm.deliveryAddressDetail" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="deliveryPhone">
						<el-input v-model="dataForm.deliveryPhone" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="姓名" prop="deliveryUserName">
						<el-input v-model="dataForm.deliveryUserName" placeholder="请输入"></el-input>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button type="info" @click="visible = false">取消</el-button>
			<el-button type="primary" @click="submit">确定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { debounce } from "@/utils/debounce";
export default {
	data() {
		return {
			visible: false,
			// 提交地址
			interfaceUrl: "",
			innerAdvanceCode: "",
			applyAdvanceCode: "",
			sendOptions: [],
			deliveryOptions: [],
			dataForm: {
				linkId: "",
				linkTable: "",
				expressType: "",
				expressNumber: "",
				sendAdvanceCode: "",
				sendProvince: "",
				sendCity: "",
				sendDistrict: "",
				sendAddressDetail: "",
				sendPhone: "",
				sendUserName: "",
				deliveryAdvanceCode: "",
				deliveryProvince: "",
				deliveryCity: "",
				deliveryDistrict: "",
				deliveryAddressDetail: "",
				deliveryPhone: "",
				deliveryUserName: "",
			},
			dataRule: {
				expressNumber: [
					{
						required: true,
						message: "快递单号不能为空",
						trigger: "blur",
					},
				],
				sendProvince: [
					{
						required: true,
						message: "省不能为空",
						trigger: "blur",
					},
				],
				sendCity: [
					{
						required: true,
						message: "市不能为空",
						trigger: "blur",
					},
				],
				sendAddressDetail: [
					{
						required: true,
						message: "详细地址不能为空",
						trigger: "blur",
					},
				],
				sendPhone: [
					{
						required: true,
						message: "联系电话不能为空",
						trigger: "blur",
					},
				],
				sendUserName: [
					{
						required: true,
						message: "姓名不能为空",
						trigger: "blur",
					},
				],
				deliveryProvince: [
					{
						required: true,
						message: "省不能为空",
						trigger: "blur",
					},
				],
				deliveryCity: [
					{
						required: true,
						message: "市不能为空",
						trigger: "blur",
					},
				],
				deliveryAddressDetail: [
					{
						required: true,
						message: "详细地址不能为空",
						trigger: "blur",
					},
				],
				deliveryPhone: [
					{
						required: true,
						message: "联系电话不能为空",
						trigger: "blur",
					},
				],
				deliveryUserName: [
					{
						required: true,
						message: "姓名不能为空",
						trigger: "blur",
					},
				],
			},
			advanceTypeFlag: false, // 是否是寄件方
		};
	},
	methods: {
		init(dt) {
			this.visible = true;
			this.$nextTick(() => {
				this.$refs.dataForm.resetFields();
				this.dataForm.linkId = dt.id;
				this.dataForm.linkTable = dt.linkTable;
				this.dataForm.expressType = dt.expressType;
				dt.advanceTypeFlag == "1" ? (this.advanceTypeFlag = true) : (this.advanceTypeFlag = false);
				this.getExpress(dt);
			});
		},
		// 根据id获取寄件和收件邮寄地址
		getExpress(dt) {
			let self = this;
			const params = {
				linkId: dt.id,
				linkTable: dt.linkTable,
				expressType: dt.expressType,
			};
			self.$request.post("getExpress", false, params, function (r) {
				if (r.code == "0") {
					if (r.data == null) {
						self.interfaceUrl = "partsClaimExpressAdd";
						delete self.dataForm.id;
						if (dt.innerAdvanceCode) {
							self.getAdvanceInfo(dt.innerAdvanceCode, "0");
						} else {
							self.getClaimRepairAdvance("0");
						}
						if (dt.applyAdvanceCode) {
							// 测试件回寄 此测试件需寄往仓库
							if (self.advanceTypeFlag) {
								self.getClaimRepairAdvance("1");
							} else {
								self.getAdvanceInfo(dt.applyAdvanceCode, "1");
							}
						} else {
							self.getClaimRepairAdvance("1");
						}
					} else {
						self.interfaceUrl = "partsClaimExpressUpdate";
						self.dataForm.id = r.data.id;
						self.dataForm.expressNumber = r.data.expressNumber;
						self.dataForm.sendAdvanceCode = r.data.sendAdvanceCode;
						self.dataForm.sendProvince = r.data.sendProvince;
						self.dataForm.sendCity = r.data.sendCity;
						self.dataForm.sendAddressDetail = r.data.sendAddressDetail;
						self.dataForm.sendPhone = r.data.sendPhone;
						self.dataForm.sendUserName = r.data.sendUserName;
						self.dataForm.deliveryAdvanceCode = r.data.deliveryAdvanceCode;
						self.dataForm.deliveryProvince = r.data.deliveryProvince;
						self.dataForm.deliveryCity = r.data.deliveryCity;
						self.dataForm.deliveryAddressDetail = r.data.deliveryAddressDetail;
						self.dataForm.deliveryPhone = r.data.deliveryPhone;
						self.dataForm.deliveryUserName = r.data.deliveryUserName;
						// 获取对应地址列表
						self.getClaimRepairAdvance("0", r.data.sendAdvanceCode);
						self.getClaimRepairAdvance("1", r.data.deliveryAdvanceCode);
					}
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 根据advanceCode获取具体地址信息
		getAdvanceInfo(advanceCode, type) {
			let self = this;
			self.$request.get(
				"getAdvanceData",
				false,
				{ advanceCode: advanceCode },
				function (r) {
					if (r.code == "0") {
						if (type == "0") {
							self.dataForm.sendAdvanceCode = r.data.advanceCode;
							self.dataForm.sendProvince = r.data.province;
							self.dataForm.sendCity = r.data.city;
							self.dataForm.sendAddressDetail = r.data.address;
							self.dataForm.sendPhone = r.data.telephone;
							self.dataForm.sendUserName = r.data.contact;
							self.getClaimRepairAdvance("0", r.data.advanceCode);
						}
						if (type == "1") {
							self.dataForm.deliveryAdvanceCode = r.data.advanceCode;
							self.dataForm.deliveryProvince = r.data.province;
							self.dataForm.deliveryCity = r.data.city;
							self.dataForm.deliveryAddressDetail = r.data.address;
							self.dataForm.deliveryPhone = r.data.telephone;
							self.dataForm.deliveryUserName = r.data.contact;
							self.getClaimRepairAdvance("1", r.data.advanceCode);
						}
					} else {
						self.$message.error(r.msg);
					}
				},
				function () {},
			);
		},
		// 获取邮寄地址列表
		getClaimRepairAdvance(type, advanceCode, query) {
			let self = this;
			const params = {};
			if (advanceCode) {
				params.advanceCode = advanceCode;
			} else {
				// 测试件回寄 此测试件需寄往仓库
				if (self.advanceTypeFlag) {
					params.advanceType = "1";
				} else {
					params.advanceType = type == "0" ? "1" : "0";
				}
			}
			if (query) {
				params.searchKey = query;
			}
			self.$request.post("getClaimRepairAdvance", false, params, function (r) {
				if (r.code == "0") {
					if (type == "0") {
						self.sendOptions = r.data.slice(0, 10);
					}
					if (type == "1") {
						self.deliveryOptions = r.data.slice(0, 10);
					}
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		handleSelect(type, value) {
			let array = type == "0" ? this.sendOptions : this.deliveryOptions;
			for (const element of array) {
				if (element.advanceCode == value) {
					if (type == "0") {
						this.dataForm.sendProvince = element.province;
						this.dataForm.sendCity = element.city;
						this.dataForm.sendAddressDetail = element.address;
						this.dataForm.sendPhone = element.telephone;
						this.dataForm.sendUserName = element.contact;
					}
					if (type == "1") {
						this.dataForm.deliveryProvince = element.province;
						this.dataForm.deliveryCity = element.city;
						this.dataForm.deliveryAddressDetail = element.address;
						this.dataForm.deliveryPhone = element.telephone;
						this.dataForm.deliveryUserName = element.contact;
					}
				}
			}
		},
		submit: debounce(function () {
			if (this.visible == false) {
				return;
			}
			this.$refs["dataForm"].validate((valid) => {
				if (valid) {
					let self = this;
					self.visible = false;
					self.$request.post(self.interfaceUrl, true, self.dataForm, function (r) {
						if (r.code == "0") {
							self.$emit("refresh", self.dataForm.linkId, self.dataForm);
							self.$message.success("保存成功");
						} else {
							self.$message.error(r.msg);
						}
					});
				} else {
					return false;
				}
			});
		}, 1000),
	},
};
</script>
<style lang="scss" scoped>
.dialog-title {
	display: block;
	text-align: center;

	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}

	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.el-form-item {
	margin-bottom: 10px;

	.el-select {
		width: 100%;
	}
}

.submit-btn {
	background-color: #117ffc;
	color: #fff;
}

.role-dialog /deep/ .el-dialog {
	border-radius: 10px !important;
}

.role-dialog /deep/ .el-dialog__body {
	padding: 0 20px !important;
}

.role-dialog /deep/ .el-form-item__label {
	padding: 0 !important;
}

.role-dialog /deep/ .el-dialog__footer {
	padding: 20px 20px 40px !important;
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
}
.ml10 {
	margin-left: 10px;
}
.mr10 {
	margin-right: 10px;
}
.mt10 {
	margin-top: 10px;
}
.el-tag {
	margin-bottom: 10px;
}
</style>
